import { connect } from 'react-redux';

import LearningAdminModulesTableList from '../components/LearningAdminModulesTableList';
import storage from '../../../../../lib/Storage';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';
import {
  loadModulesAdmin,
  loadModuleIdsAdmin,
  deleteModuleAdmin,
  deleteModulesAdmin,
} from '../../../../../state/modules/learningsAdmin/actions';

const mapStateToProps = (state, ownProps) => {
  const partnershipId = storage.get('local', 'partnershipId');

  const page = ownProps.page;
  const limit = ownProps.limit;
  const order = ownProps.order;

  const result = state.learningsAdmin.getIn([
    'modulesAdmin',
    partnershipId,
    'pages',
    order,
    limit,
    page,
  ]);

  return {
    partnershipId,
    isLoading: state.learningsAdmin.get('isLoading'),
    isLoadingIds: state.learningsAdmin.get('isLoadingIds'),
    total: state.learningsAdmin.getIn([
      'modulesAdmin',
      partnershipId,
      'totalModulesAdmin',
    ]),
    ids: state.learningsAdmin.get('ids').toArray(),
    list: result
      ? result
          .map((x) => {
            return {
              key: x,
              ...denormalize(
                state.entities.getIn(['learningModulesAdmin', x]),
                schema.learningModuleAdmin,
                state.entities.toJS()
              ),
            };
          })
          .toArray()
      : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadIds: (id, filter, cb) => {
      dispatch(loadModuleIdsAdmin(id, filter, cb));
    },
    load: (partnershipId, filter, page, limit, order, cb) => {
      dispatch(loadModulesAdmin(partnershipId, filter, page, limit, order, cb));
    },
    remove: (partnershipId, id, cb) => {
      dispatch(deleteModuleAdmin(partnershipId, id, cb));
    },
    removes: (partnershipId, payload, cb) => {
      dispatch(deleteModulesAdmin(partnershipId, payload, cb));
    },
  };
};

const LearningAdminModulesTableListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModulesTableList);

export default LearningAdminModulesTableListContainer;
